export default {
    /**
     * Post 郵便番号CSVインポート
     */
    importPostalCsv (data) {
        return axios.post(route('setting.postal.import'), data)
    },

    /**
     * Post システムメール送信情報取得
     */
    loadSysMailInfo () {
        return axios.post(route('setting.mail.init.info'))
    },

    /**
     * Post システムメールグループ名・ステータス修正
     */
    mailGroupEditSave (data) {
        return axios.post(route('setting.mail.group.edit'), data)
    },

    /**
     * Post システムメールグループ削除
     */
    mailGroupEditDel (data) {
        return axios.post(route('setting.mail.group.del'), data)
    },

    /**
     * Post システムメール送信グループ
     */
    loadMailGroupMember (data) {
        return axios.post(route('setting.mail.group.member'), data)
    },

    /**
     * Post メールグループ変更
     */
    changeMailGroup (data) {
        return axios.post(route('setting.mail.group.change'), data)
    },

    /**
     * Post メールグループテンプレート保存
     */
    mailTempSave (data) {
        return axios.post(route('setting.mail.temp.save'), data)
    },

    /**
     * Post メールグループテンプレート削除
     */
    mailTempDel (data) {
        return axios.post(route('setting.mail.temp.del'), data)
    },

    /**
     * Post メール送信
     */
    sysMailSend (data) {
        return axios.post(route('setting.mail.send'), data)
    },
}
